<template>
  <div class="student-leave-detail" v-if="detail.status">
    <!-- 顶部状态 -->
    <div class="status-header">
      <div class="status-tag" :class="detail.status == 10 && detail.supplement_flag == 0 ? 'pending' : detail.status == 30 ? 'reject' : detail.status == 20 ? 'approve' : detail.status == 10 && detail.supplement_flag == 1 ? 'need_supplement' : ''">
        <van-icon name="clock-o" class="font14" color="#1989fa" v-if="detail.status == 10 && detail.supplement_flag == 0" />
        <van-icon name="close" class="font14" color="#EE0A24" v-else-if="detail.status == 30" />
        <van-icon name="passed" class="font14" color="#07C160" v-else-if="detail.status == 20" />
        <van-icon name="warning-o" class="font14" color="#ED6A0C" v-else-if="detail.status == 10 && detail.supplement_flag == 1" />
        <span class="status-text">{{ detail.status == 10 && detail.supplement_flag == 0 ? $t("leave.pending") : detail.status == 30 ? $t("leave.rejected") : detail.status == 20 ? $t("leave.approved") : detail.status == 10 && detail.supplement_flag == 1 ? $t("leave.supplement_material") : "" }}</span>
      </div>
      <!-- 学生信息 -->
      <div class="student-card">
        <img :src="detail.child_photo" class="student-avatar" />
        <div class="student-info">
          <div class="student-name">{{ detail.child_name }}</div>
          <div class="student-grade">{{ detail.class_title }}</div>
        </div>
      </div>
    </div>

    <!-- 请假信息 -->
    <div class="section info-section">
      <div class="section-title">{{ $t("leave.leave_info") }}</div>
      <div class="info-row">
        <span class="label">{{ $t("leave.leave_type") }}</span>
        <span class="value">{{ detail.leave_type_label }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ $t("leave.date") }}</span>
        <div class="value date-list">
          <div class="date-item" :class="detail.days.length != 1 ? 'borderBto' : ''" v-for="(date, idx) in detail.days" :key="idx">
            <div class="date-line" :class="idx != 0 ? 'pt-5' : ''">{{ date.leave_date_text }}</div>
            <div class="time-line">
              <span v-for="(period, i) in date.periods" :key="period.id">{{ period.time_label }}<span v-if="i < date.periods.length - 1">、</span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="info-row">
        <span class="label">{{ $t("leave.reason") }}</span>
        <span class="value reason" v-html="detail.reason"></span>
      </div>
      <div class="info-row" v-if="detail.attachments && detail.attachments.length">
        <span class="label">{{ $t("leave.attachment") }}</span>
        <div class="value attachments">
          <span v-for="(img, idx) in detail.attachments" :key="idx" class="attachment-img">
            <img :src="img.url" @click="previewImage(idx)" />
            <span class="attachment-text" v-if="img.supplement == 1">{{ $t("leave.Supplement") }}</span>
          </span>
        </div>
      </div>
    </div>
    <!-- 实际考勤 -->
    <div class="section attendance-section" v-if="detail.status == 20 && detail.division==20">
      <div class="section-title">{{ $t("leave.Attendance") }}</div>
      <template v-if="detail.days && detail.days.length">
        <div class="attendance-group" v-for="(day, idx) in detail.days" :key="idx">
          <div class="attendance-date">{{ day.leave_date_text }}</div>
          <div class="attendance-box" v-if="detail.division == 20">
            <div class="attendance-row" v-for="(item, i) in day.sign_records" :key="i">
              <span class="attendance-left">#{{ item.period }} ({{ item.time }})</span>
              <span class="attendance-status" :class="{ 'is-na': item.status == 99 }">{{ item.status == 99 ? $t("leave.Cancelled") : item.type_label }}</span>
            </div>
          </div>
          <div class="attendance-box" v-if="detail.division == 10">
            <div class="attendance-row" v-for="(item, i) in day.attendance_records" :key="i">
              <span class="attendance-left">{{ $t("leave.full_day") }}</span>
              <span class="attendance-status" :class="{ 'is-na': item.status == 99 }">{{ item.status == 99 ? $t("leave.Cancelled") : item.type_label }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 审批进度 -->
    <div class="section timeline-section">
      <div class="section-title">{{ $t("leave.Progress") }}</div>
      <div class="timeline">
        <div class="timeline-item" v-for="(item, idx) in detail.timeline" :key="idx">
          <div class="timeline-left">
            <div class="timeline-dot" :class="detail.status == 10 && detail.supplement_flag == 0 ? 'dot-pending' : ''"></div>
            <div class="timeline-line" v-if="idx !== detail.timeline.length - 1" :class="detail.status == 10 && detail.supplement_flag == 0 ? 'line-pending' : ''"></div>
          </div>
          <div class="timeline-content">
            <div class="timeline-header">
              <span class="timeline-type">{{ item.event_label }}</span>
              <span class="timeline-status pending" v-if="item.is_default == 1">{{ $t("leave.pending") }}</span>
              <span class="timeline-status" :class="item.event" v-else-if="item.actor_type == 20">{{ item.event_status }}</span>
              <span class="timeline-time">{{ item.created_at_text }}</span>
            </div>
            <div class="timeline-body" v-if="item.actor_type == 20 || item.comment">
              <div class="approver" v-if="item.actor_type == 20">
                <img :src="item.actor_avatar" class="approver-avatar" />
                <span class="approver-name">{{ item.actor_name }}</span>
              </div>
              <div class="remark" v-if="item.comment" v-html="item.comment"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 留言 -->
    <div class="section">
      <div class="section-title">{{ $t("contact.message") }}</div>
      <div class="messages">
        <van-field v-model="message" rows="1" autosize type="textarea" :placeholder="$t('contact.message')"  class="message-input" />
        <van-button type="info" size="small" :disabled="!message || messageBtn" class="btn-send" @click="sendMessage">{{ $t("contact.send")  }}</van-button>
      </div>
      <div class="message-list">
        <div v-for="(item, index) in detail.leaveMessage" :key="index">
          <van-divider v-if="item.sender_type == 0" class="font12" :style="{ color: '#07C160', borderColor: '#EBEDF0' }"> {{ $t("leave.Resolved") }} </van-divider>
          <div class="message-item" v-else>
            <img :src="item.sender_type == 20 ? item.sender_avatar : detail.child_photo" alt="" class="message-avatar" />
            <div class="message-item-info">
              <div class="message-item-title">
                <span class="flex1">{{ item.sender_type == 20 ? item.sender_name : detail.child_name }}</span>
                <span class="color9">{{ item.created_at_text }}</span>
              </div>
              <div class="message-item-content" v-html="item.content"></div>
              <div v-if="item.sender_type == 10" class="color9 font12 mt-10">
                {{ item.sender_identity == 'm' ? $t("contact.form_m") : $t("contact.form_f") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部操作 -->
    <div class="bottom-actions" v-if="(detail.status == 10 && detail.supplement_flag == 0) || (detail.status == 10 && detail.supplement_flag == 1)">
      <div class="btn-cancel" @click="cancelLeave">
        <van-icon name="revoke" size="16" /><span class="ml-5">{{ $t("leave.cancel_leave") }}</span>
      </div>
      <div class="btn-add" @click="addMaterial">
        <van-icon name="plus" size="16" /><span class="ml-5">{{ $t("leave.add_material") }}</span>
      </div>
    </div>
    <van-popup v-model="showImg" position="bottom" round>
      <div class="schedule-popup">
        <div class="popup-header">
          <span class="popup-title">{{ $t("leave.add_material") }}</span>
          <van-icon name="cross" @click="showImg = false" />
        </div>
        <!-- <van-notice-bar background="#FDF0E6" color="#ED6A0C" left-icon="info-o" wrapable> 提交补充材料将重新发起审批，状态为“待审批” </van-notice-bar> -->
        <div class="schedule-list">
          <div class="attachment-area">
            <van-uploader v-model="fileList" :max-size="1024 * 1024 * 50" @oversize="onOversize" :after-read="afterRead" :max-count="9" multiple @delete="onDeleteFile" />
          </div>
        </div>
        <div class="popup-actions">
          <div class="btn-confirm" :class="{ 'is-disabled': submitting }" @click="submitAttachments">{{ $t("global.submit") }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast, Dialog, ImagePreview } from "vant";
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Dialog);
import { detailLeave, cancelLeave, supplementLeave, qiniuToken, addMessage } from "@/api/leave";
import * as qiniu from "qiniu-js";

export default {
  name: "StudentLeaveDetail",
  data() {
    return {
      detail: {},
      statusText: "Rejected",
      status: 3,
      attachments: [],
      fileList: [],
      token: "",
      showImg: false,
      detailId: "",
      submitting: false,
      message: "",
      messageBtn: false,
      messageList: [
        { avatar: "https://oa.daystar.ivyonline.cn/uploads/childmgt/avatar/202401/679c70faea1c0d6e6a433c3a4cb73b8a!w200", title: "Isla 吕姮", content: "请取消9月16日第1、2节的请假", date: "2024-01-16" },
        { avatar: "https://oa.daystar.ivyonline.cn/uploads/childmgt/avatar/202401/679c70faea1c0d6e6a433c3a4cb73b8a!w200", title: "Isla 吕 Constable", content: "请取消9月16日第1、2节的请假", date: "2024-01-16" },
      ],
    };
  },
  computed: {},
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f7f8fa");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  created() {
    const id = this.$route.params.id;
    if (id) {
      this.detailId = id;
      this.fetchDetail(id);
    }
  },
  methods: {
    fetchDetail(id) {
      detailLeave({ id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data;
        }
      });
    },
    isNaStatus(status) {
      return status === "NA" || status === "N/A";
    },
    previewImage(idx) {
      let images = [];
      this.detail.attachments.forEach((item) => {
        images.push(item.url);
      });
      ImagePreview({
        images: images,
        startPosition: idx,
        closeable: true,
      });
    },
    cancelLeave() {
      this.$dialog
        .confirm({
          title: this.$t("leave.cancel_leave"),
          message: this.$t("leave.confirm_cancel_leave"),
        })
        .then(() => {
          cancelLeave({ id: this.detail.id }).then((res) => {
            if (res.code == 0) {
              Toast.success(res.msg);
              this.$router.back();
            }
          });
        })
        .catch(() => {});
    },
    addMaterial() {
      qiniuToken().then((res) => {
        if (res.code == 0) {
          this.token = res.data.token;
          this.showImg = true;
        }
      });
    },
    afterRead(file) {
      const files = Array.isArray(file) ? file : [file];
      files.forEach((item) => {
        this.uploadToQiniu(item);
      });
    },
    onOversize() {
      Toast("文件大小不能超过 50MB");
    },
    onDeleteFile(file) {
      // 同步移除 this.attachments 中对应的附件数据
      if (file && file.qiniuAttachment) {
        const idx = this.attachments.indexOf(file.qiniuAttachment);
        if (idx > -1) {
          this.attachments.splice(idx, 1);
        }
      }
    },
    uploadToQiniu(fileItem) {
      fileItem.status = "uploading";
      fileItem.message = this.$t("contact.Uploading") || "上传中";
      const config = { useCdnDomain: true, region: qiniu.region.z1 };
      const putExtra = { fname: fileItem.file.name, params: {}, mimeType: null };
      const key = fileItem.file.name;
      const observable = qiniu.upload(fileItem.file, key, this.token, putExtra, config);
      observable.subscribe({
        next: () => {},
        error: () => {
          fileItem.status = "failed";
          fileItem.message = this.$t("pickupcard.upload_failed") || "上传失败";
          Toast(this.$t("pickupcard.Upload_failed") || "上传失败");
        },
        complete: (res) => {
          fileItem.status = "done";
          if (this.fileList.indexOf(fileItem) === -1) return;
          const attachment = { url: res.data.key, file_name: res.data.name, file_size: res.data.size, mime_type: res.data.mimeType };
          fileItem.qiniuAttachment = attachment;
          this.attachments.push(attachment);
        },
      });
    },
    submitAttachments() {
      if (this.submitting) return;
      this.submitting = true;
      supplementLeave({
        id: this.detail.id,
        attachments: this.attachments,
      })
        .then((res) => {
          if (res.code == 0) {
            Toast.success(res.msg);
            this.showImg = false;
            this.fileList = [];
            this.attachments = [];
            this.fetchDetail(this.detailId);
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    sendMessage() {
      if (this.message == "") {
        return;
      }
      this.messageBtn = true;
      addMessage({ id: this.detail.id, content: this.message }).then((res) => {
        if (res.code == 0) {
          Toast.success(res.msg);
          this.fetchDetail(this.detailId);
          this.message = "";
          this.messageBtn = false;
        } else {
          this.messageBtn = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.student-leave-detail {
  // min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 67px;

  .status-header {
    background: #ffffff;
    border-radius: 12px;
    margin: 8px;

    .status-tag {
      border-radius: 12px 12px 0px 0px;
      padding: 4px;
      text-align: center;

      &.pending {
        background: #e8f3ff;
        color: #1989fa;
      }

      &.approve {
        color: #07c160;
        background: rgba(7, 193, 96, 0.1);
      }

      &.need_supplement {
        background: #fdf0e6;
        color: #ed6a0c;
      }
      &.reject {
        color: #ee0a24;
        background: #feecee;
      }

      .status-icon {
        line-height: 1;
      }
    }
    .status-text {
      font-size: 14px;
      margin-left: 8px;
    }
    .student-card {
      display: flex;
      align-items: center;
      padding: 20px 16px;

      .student-avatar {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        object-fit: cover;
      }

      .student-info {
        flex: 1;
        margin-left: 8px;

        .student-name {
          font-size: 14px;
          font-weight: 500;
          color: #323233;
        }

        .student-grade {
          font-size: 12px;
          color: #646566;
          margin-top: 2px;
        }
      }
    }
  }

  .section {
    background: #fff;
    border-radius: 12px;
    margin: 8px;
    padding: 16px;

    .section-title {
      font-size: 16px;
      font-weight: 500;
      color: #323233;
      margin-bottom: 16px;
    }
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      min-width: 80px;
      font-size: 14px;
      color: #969799;
      line-height: 1.5;
    }

    .value {
      flex: 1;
      font-size: 14px;
      color: #323233;
      line-height: 1.5;
      word-break: break-word;

      &.reason {
        color: #323233;
      }
    }

    .date-list {
      .borderBto {
        border-bottom: 0.5px solid #dcdee0;
      }
      .date-item {
        padding-bottom: 6px;

        &:last-child {
          margin-bottom: 0;
        }

        .date-line {
          font-size: 14px;
          color: #323233;
        }

        .time-line {
          font-size: 13px;
          color: #646566;
          margin-top: 2px;
        }
      }
    }

    .attachments {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;

      .attachment-img {
        width: 80px;
        height: 80px;
        position: relative;
        img {
          width: 80px;
          height: 80px;
          border-radius: 8px;
          object-fit: cover;
        }
        .attachment-text {
          font-size: 12px;
          color: #fff;
          padding: 2px 4px;
          background: #ed6a0c;
          border-radius: 8px 0px 8px 0px;
          position: absolute;
          left: 0;
          top: 0;
          line-height: 1;
        }
      }
    }
  }

  .attendance-section {
    .attendance-group {
      margin-bottom: 18px;

      &:last-child {
        margin-bottom: 0;
      }

      .attendance-date {
        font-size: 14px;
        color: #323233;
        margin-bottom: 8px;
      }

      .attendance-box {
        background: #f5f6f8;
        border-radius: 8px;
        padding: 8px 12px;

        .attendance-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 6px 0;
          font-size: 12px;

          .attendance-left {
            color: #646566;
          }

          .attendance-status {
            color: #323233;

            &.is-na {
              color: #c8c9cc;
            }
          }
        }
      }
    }
  }

  .timeline {
    margin-top:24px;
    .timeline-item {
      display: flex;
      position: relative;
      min-height: 50px;

      &.last {
        padding-bottom: 0;
      }

      .timeline-left {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 16px;
        margin-right: 12px;
        // padding-top: 6px;
        .timeline-dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          border: 2px solid #1989fa;
          background: #fff;
          z-index: 1;
        }
        .dot-pending {
          &:last-child {
            border: 2px solid #969799;
          }
        }
        .timeline-line {
          position: absolute;
          top: 5px;
          bottom: 0;
          width: 1px;
          background: #1989fa;
        }
      }

      .timeline-content {
        flex: 1;
        min-width: 0;

        .timeline-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 6px;
          margin-top: -4px;

          .timeline-type {
            font-size: 14px;
            font-weight: 500;
            color: #323233;
            line-height: 1;
          }

          .timeline-status {
            font-size: 12px;
            padding: 4px 6px;
            border-radius: 104px;
            font-weight: 500;
            line-height: 1;
            margin-top: 4px;
            &.pending {
              background: #e8f3ff;
              color: #1989fa;
            }

            &.approve {
              color: #07c160;
              background: rgba(7, 193, 96, 0.1);
            }

            &.need_supplement {
              background: #fdf0e6;
              color: #ed6a0c;
            }
            &.reject {
              color: #ee0a24;
              background: #feecee;
            }

            .status-icon {
              line-height: 1;
            }
          }

          .timeline-time {
            margin-left: auto;
            font-size: 12px;
            color: #969799;
            white-space: nowrap;
          }
        }

        .timeline-body {
          .approver {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 4px;

            .approver-avatar {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              object-fit: cover;
            }

            .approver-name {
              font-size: 13px;
              color: #646566;
            }
          }

          .remark {
            font-size: 12px;
            color: #646566;
            line-height: 1.5;
            background: #f5f6f8;
            padding: 4px 8px;
            margin-bottom: 20px;
            border-radius: 4px;
          }
        }
      }
    }
  }

  .bottom-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    gap: 12px;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: #fff;
    border-top: 1px solid #f2f3f5;
    z-index: 10;

    .btn-cancel,
    .btn-add {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 0;
      border-radius: 22px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
    }

    .btn-cancel {
      color: #ee0a24;
      border: 1px solid #ee0a24;
      background: #fff;
    }

    .btn-add {
      color: #1989fa;
      border: 1px solid #1989fa;
      background: #fff;
      gap: 4px;
    }
  }
  .schedule-popup {
    padding: 16px 0;
    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 8px 10px;
      .popup-title {
        font-size: 16px;
        font-weight: 500;
        color: #323233;
        flex: 1;
        text-align: center;
      }

      .van-icon {
        font-size: 20px;
        color: #969799;
        cursor: pointer;
      }
    }
    .schedule-list {
      padding: 16px;
    }
    .popup-actions {
      display: flex;
      gap: 12px;
      margin-top: 20px;
      padding: 0 16px;
      .btn-confirm {
        flex: 1;
        text-align: center;
        padding: 10px 0;
        font-size: 15px;
        border-radius: 20px;
        color: #fff;
        background: #1989fa;
        &.is-disabled {
          opacity: 0.6;
          pointer-events: none;
        }
      }
    }
  }
}
.messages {
  display: flex;
  align-items: end;
  .message-input {
    flex: 1;
    padding: 4px 12px;
    font-size: 14px;
    border-radius: 4px 4px 4px 4px;
    background: #f5f6f8;
  }
  .btn-send {
    margin-left: 10px;
    font-size: 14px;
    padding: 10px;
    border-radius: 5px;
    height: 32px;
    background: #1989fa;
  }
}
.message-list {
  margin-top: 24px;

  .message-item {
    display: flex;
    margin-top: 16px;
    .message-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      object-fit: cover;
    }
    .message-item-info {
      flex: 1;
      margin-left: 8px;
      .message-item-title {
        display: flex;
        font-size: 12px;
        color: #666666;
        align-items: center;
        .flex1 {
          flex: 1;
        }
      }
      .message-item-content {
        margin-top: 8px;
        font-size: 14px;
        color: #333333;
      }
    }
  }
}
</style>
